enum BomObjectType {
    ProductGroup = "productGroup",
    Characteristic = "characteristic"
}

export interface BomObject {
    bomId: string
    children: BomObject[]
    id: string
    parentId: string
    properties: object
    type: BomObjectType
}
